import { render, staticRenderFns } from "./p-register.vue?vue&type=template&id=0f1b103a&scoped=true"
import script from "./p-register.vue?vue&type=script&lang=js"
export * from "./p-register.vue?vue&type=script&lang=js"
import style0 from "./p-register.vue?vue&type=style&index=0&id=0f1b103a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1b103a",
  null
  
)

export default component.exports